import { McpStatusBadges, type McpStatusBadgesProps } from "./McpStatusBadges";

export function McpOverviewHeader(props: McpStatusBadgesProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 pt-2">
      <h3 className="text-sm font-medium text-foreground">Trace Details</h3>
      <McpStatusBadges {...props} />
    </div>
  );
}
